import React, { useEffect } from "react";
import { connect } from "react-redux";
import Routes from "./Routes";
import { initResizeListener } from "eventListener";
import get from "lodash/get";
import { windowResizeAction, refreshTokenAction } from "store/actions";
import styled from "styled-components";
import { compose } from "redux";
import { withRouter } from "react-router";
import LoadingSpinner from "components/LoadingSpinner";
import HiddenOn from "components/common/HiddenOn";

function App({ resize, isMobile, refreshToken, signedIn }) {
  useEffect(() => {
    console.log(
      "%c Oi you! Get out of the console!",
      "background: #222; color: #bada55"
    );

    initResizeListener(resize);
  }, [isMobile, resize]);

  useEffect(() => {
    const congitoKey = window.localStorage.cognitoKey;
    if (congitoKey) {
      refreshToken();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const hasToken = !!window.localStorage.accessToken;

  return (
    <Container id={"Container"} isMobile={isMobile}>
      <HiddenOn
        hideOn={hasToken && !signedIn}
        fallback={<LoadingSpinner text={"Relogging you in..."} />}
      >
        <Routes />
      </HiddenOn>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  flex-direction: column;
  background: #292b2f;
  color: #d3d3d4;
`;

export const mapStateToProps = (state) => ({
  isMobile: get(state, "rootReducer.core.isMobile", false),
  signedIn: get(state, "rootReducer.core.user.signedIn", false),
});

const mapDispatchToProps = {
  resize: windowResizeAction,
  refreshToken: refreshTokenAction,
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(App);
